export const zIndexes = {
	nodeDetailBoxes: 5,
	dropdown: 7,
	draggable: 10,
	//scrollBars: 10, // for ref; in react-vscrollview
	subNavBar: 15,
	actionBar: 15,
	navBar: 16, // since has dropdowns over sub-nav-bar/action-bar
	overNavBarDropdown: 17,
	tourDotPopup: 18,
	//messageBox: 20, // for ref; in Main.scss
};